import eventDispatcher from '../events/dispatch';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      currentUser: state => state.main.currentUser,
    }),
    forceLoad() {
      const { search } = window.location;

      return search.indexOf('forcewidget=true') > -1;
    },
  },
  methods: {
    async initializeMarketingWidget() {
      try {
        const {
          given_name = '',
          family_name = '',
          email,
          createdAt,
        } = this.currentUser || {};
        const shouldLoadWidget = (email && !email.includes('@mikmak.com')) || this.forceLoad;

        if (!shouldLoadWidget) return;

        eventDispatcher('marketingWidgetLoadStarted');

        // service to generate email hash required to initialize widget
        const { success, data: hashedEmail } = await $.ajax({
          url: `https://us-central1-mikmak-hash-service.cloudfunctions.net/hash?value=${email}`,
          type: 'GET',
        });

        if (success) {
          const unixCreatedAt = createdAt && Math.round((new Date(createdAt)).getTime() / 1000);
          const config = {
            domain_key: 'mikmak',
            template_name: 'Default',
            name: given_name ? `${given_name} ${family_name}` : '',
            email: email,
            email_hash: hashedEmail,
            created: unixCreatedAt,
            close_left: false,
          };

          if (this.forceLoad) {
            config.force = true;
          }
          const { initialised, status } = window.askNicelyConversation({
            config,
          });

          if (initialised) {
            eventDispatcher('marketingWidgetInitialized', { message: status });
          } else {
            eventDispatcher('marketingWidgetLoadError', { error_message: status });
          }
        }
      } catch (e) {
        const { message } = e.responseJSON ? e.responseJSON : e;

        eventDispatcher('marketingWidgetLoadError', { error_message: message });
      }
    },
  },
};
